import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const WellnessCenter = () => {
  const [activeImage, setActiveImage] = useState(0);

  const facilityData = {
    name: 'Wellness Center',
    category: 'Wellness',
    description: 'Holistic wellness center with spa, gym, and fitness classes.',
    longDescription: 'Our comprehensive Wellness Center is dedicated to your physical and mental well-being. Featuring a fully equipped gym, luxurious spa treatments, relaxing sauna, and diverse fitness classes, it offers everything you need to recharge and rejuvenate. Our professional staff is committed to helping you achieve your wellness goals.',
    images: [
      getImagePath('images/bars/wellness-center.jpg'),
      getImagePath('images/bars/wellness-center.jpg'),
      getImagePath('images/bars/wellness-center.jpg')
    ],
    icon: 'fa-spa',
    capacity: '50 members',
    hours: 'Daily: 6am - 10pm',
    features: [
      'Fully Equipped Gym',
      'Spa & Massage',
      'Sauna & Steam Room',
      'Yoga Studio',
      'Group Fitness Classes',
      'Personal Training',
      'Nutrition Counseling',
      'Relaxation Lounge'
    ],
    amenities: ['Locker Rooms', 'Towels', 'Water Station', 'Juice Bar'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'wellness@nlngraclub.com',
      extension: '114'
    },
    treatments: ['Massage', 'Facial', 'Body Scrub', 'Aromatherapy'],
    classes: ['Yoga', 'Pilates', 'Zumba', 'Meditation', 'Strength Training']
  };

  return (
    <div className="facility-detail-page">
      {/* Hero Section */}
      <section className="facility-detail-hero">
        <div className="hero-background">
          <img src={facilityData.images[0]} alt={facilityData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/facilities" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Facilities
            </Link>
            <span className="facility-category">{facilityData.category}</span>
            <h1 className="facility-title">{facilityData.name}</h1>
            <p className="facility-subtitle">{facilityData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Facility Content */}
      <section className="facility-content-section">
        <div className="container">
          <div className="facility-grid">
            {/* Left Column - Images */}
            <div className="facility-gallery">
              <div className="main-image">
                <img 
                  src={facilityData.images[activeImage]} 
                  alt={facilityData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {facilityData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${facilityData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="facility-details">
              <div className="detail-section">
                <h2>About {facilityData.name}</h2>
                <p className="facility-description">{facilityData.longDescription}</p>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {facilityData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="info-grid">
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <h4>Hours</h4>
                  <p>{facilityData.hours}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <h4>Capacity</h4>
                  <p>{facilityData.capacity}</p>
                </div>
                <div className="info-card">
                  <i className="fas fa-phone"></i>
                  <h4>Contact</h4>
                  <p>{facilityData.contact.phone} ext. {facilityData.contact.extension}</p>
                </div>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Treatments:</span>
                  <span className="info-value">{facilityData.treatments.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Classes:</span>
                  <span className="info-value">{facilityData.classes.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/rlogin" className="btn btn-primary btn-large">
                  <i className="fas fa-calendar-check"></i> Book a Treatment
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Class Schedule
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WellnessCenter;